<template>
	<div class="conditions-group flex-space-between--center">
		<div class="condition-editor">
			<div class="column-name">
				<ConditionSourceParamType :param="sourceParamType" v-bind="componentProps" v-on="componentListeners" :items="tableItems" />
			</div>
			<div class="display-flex width-100">
				<div class="condition-selector-container" :class="{ [getSingularClassName(conditionGroupId)]: true }">
					<div class="condition-selector">
						<AppSelect
							item-value="operator"
							item-text="displayText"
							:attach="`.condition-selector-container.${getSingularClassName(conditionGroupId)}`"
							naked
							v-model="condition"
							:items="selectOptions"
							return-object
							@change="onChange"
							:readonly="readonly"
						/>
					</div>
				</div>
				<div class="value-input" :class="{ disabled: !showValueInput }">
					<ConditionValueParamType v-if="showValueInput" :param="valueParamType" v-bind="componentProps" v-on="componentListeners" />
				</div>
			</div>
		</div>
		<div class="remove-btn" v-show="canRemove">
			<RemoveIcon class="remove-icon" @click="$emit('removeOption', conditionGroupId)" />
		</div>
	</div>
</template>

<script>
import ConditionSourceParamType from '../../../BlockEditorParams/ParamTypes/RulesParams/ConditionSourceParamType';
import ConditionValueParamType from '../../../BlockEditorParams/ParamTypes/RulesParams/ConditionValueParamType';
import RemoveIcon from '../../../../BlockEditorWidget/assets/icon-remove-option.svg';
import ConditionEditorMixin from './ConditionEditorMixin';
export default {
	name: 'ConditionEditor',
	mixins: [ConditionEditorMixin],
	props: {},
	components: {
		ConditionSourceParamType,
		ConditionValueParamType,
		RemoveIcon,
	},
	computed: {},
	methods: {},
	mounted() {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
@import './condition-editor.scss';
</style>
